/* ------------------------------------------------------------------------------
 *
 *  # Tipo Categoria Management Components
 *
 *  Grid de Tipos de Categoría con acciones
 *
 * ---------------------------------------------------------------------------- */

import { destroyDataTable, initGenericDataTable } from '../integrations/datatables.js';

// Callback reference
let tipoCategoriaCallbacks = null;

export function initTipoCategoriaTable(tipoCategorias) {
    destroyDataTable('tipoCategoriaTable');

    const tableData = tipoCategorias.map(tc => [
        generateActions(tc),
        tc.nombre,
        tc.descripcion,
        tc.orden,
        tc.activo ? 'Activo' : 'Inactivo',
        tc.esParaActividades ? 'Sí' : 'No'
    ]);

    const options = {
        data: tableData,
        columns: [
            { title: 'Acciones', orderable: false, className: 'text-center', width: '120px' },
            { title: 'Nombre' },
            { title: 'Descripción' },
            { title: 'Orden', className: 'text-center' },
            { title: 'Estado', className: 'text-center' },
            { title: 'Para Actividades', className: 'text-center' }
        ],
        order: [[1, 'asc']]
    };

    initGenericDataTable('tipoCategoriaTable', options);
}

function generateActions(tipoCategoria) {
    return `
        <div class="d-inline-flex">
            <a href="javascript:void(0)" class="text-body me-2" onclick="window.sfBlazorSB.tipoCategorias.edit(${tipoCategoria.id})" title="Editar">
                <i class="ph-pencil"></i>
            </a>
            <a href="javascript:void(0)" class="text-body" onclick="window.sfBlazorSB.tipoCategorias.delete(${tipoCategoria.id})" title="Eliminar">
                <i class="ph-trash"></i>
            </a>
        </div>
    `;
}

// Refresh table
export function refreshTipoCategoriaTable(tipoCategorias) {
    destroyDataTable('tipoCategoriaTable');
    initTipoCategoriaTable(tipoCategorias);
}

// Set callbacks
export function setTipoCategoriaCallbacks(dotNetRef) {
    tipoCategoriaCallbacks = dotNetRef;
}

// Edit action
export function editTipoCategoria(id) {
    if (tipoCategoriaCallbacks) {
        tipoCategoriaCallbacks.invokeMethodAsync('EditTipoCategoria', id);
    }
}

// Delete action
export async function deleteTipoCategoria(id) {
    const result = await window.swalInit.fire({
        title: '¿Eliminar Tipo de Categoría?',
        text: '¿Estás seguro de que deseas eliminar este tipo de categoría?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#dc3545'
    });

    if (result.isConfirmed && tipoCategoriaCallbacks) {
        await tipoCategoriaCallbacks.invokeMethodAsync('DeleteTipoCategoria', id);
    }
}
